<template>
  <div>
    <div v-if="titleVisible" class="tw-text-2xl tw-text-danger tw-font-bold">
      <slot />
    </div>
    <div v-if="credentialsSentVisible">
      You will receive an email with instructions to reset your password.
      Remember to check your spam box. If you don't receive the email please
      <ContactLink /> for further assistance.
    </div>
    <div v-else-if="error == 'mfUserMoved'">
      <p>This account already has access to Spellingframe.</p>
      <template v-if="isMfSchool">
        <p>
          If you are the admin of this school and you don't remember you login
          credentials to access Spellingframe features
          <a href="" @click.prevent="sendCredentials">click here</a>.
        </p>
        <p>
          If you are a student of this school please contact your teacher to get
          your credentials.
        </p>
        <p>
          If you are a teacher of this school please contact your school admin
          to get your credentials.
        </p>
      </template>
      <p v-else>
        If you don't remember your credentials to access Spellingframe features
        <a href="" @click.prevent="sendCredentials">click here</a>.
      </p>
    </div>
    <div v-else-if="error == 'noMfUser'">
      <p>The current user doesn't seem to be linked to a Mathsframe account.</p>
      <p>
        Please logout and login again using your Mathsframe credentials or
        <ContactLink /> to get further assistance.
      </p>
    </div>
    <div v-else-if="error == 'logedout'">
      <p>
        You have been logged out. Please login again with your Mathsframe
        credentials.
      </p>
    </div>
    <div v-else>
      <p>
        Please
        <span v-if="showTryAgain"
          ><a href="" @click.prevent="$emit('tryagain')">try again</a> or</span
        >
        <ContactLink /> to get further assistance.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import ContactLink from "@/components/ui/ContactLink.vue";
import apiCall from "@/func/net/apiCall";
import userHasRole from "@/func/user/userHasRole";
import { defineComponent } from "vue";

export default defineComponent({
  components: { ContactLink },
  emits: ["tryagain"],
  props: {
    error: { type: String, default: "" },
    showTryAgain: { type: Boolean, default: false },
  },
  data() {
    return {
      credentialsSentVisible: false,
    };
  },
  computed: {
    isMfSchool() {
      return userHasRole(this.$currentUser.value, "mfSchool");
    },
    titleVisible() {
      return !this.credentialsSentVisible;
    },
  },
  methods: {
    async sendCredentials() {
      const params = { mfuser: 1 };
      const data = await apiCall("auth/reset-password", params);
      if (data.success) {
        this.credentialsSentVisible = true;
      }
    },
  },
});
</script>
